export default {
  'no-kid-found:title': 'Мы не смогли найти ваших детей в госбазе',
  'no-kid-found:call-center-not-found': 'По всем вопросам </br>звоните на номер',
  'no-kid-found:btn': 'Вернуться на Главную Kaspi.kz'
}
